<div
  *ngIf="open"
  id="popup-modal"
  tabindex="-1"
  role="dialog"
  aria-modal="true"
  class="fixed inset-0 z-50 flex justify-center items-center w-full h-full bg-gray-900/50 p-4"
  (click)="onCancel()"
>
  <div class="relative w-full max-w-md max-h-full" (click)="$event.stopPropagation()">
    <div class="relative bg-white rounded-lg shadow dark:bg-gray-700">
      <button
        type="button"
        (click)="onCancel()"
        class="absolute top-3 end-2.5 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"
      >
        <ng-icon name="heroXMark" size="18px"></ng-icon>
        <span class="sr-only">Fechar</span>
      </button>
      <div class="p-4 md:p-5 text-center">
        <svg
          class="mx-auto mb-4 text-gray-400 w-12 h-12 dark:text-gray-200"
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 20 20"
        >
          <path
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M10 11V6m0 8h.01M19 10a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
          />
        </svg>
        <h3 class="mb-3 text-lg font-normal text-gray-700 dark:text-gray-300">
          {{ title }}
        </h3>
        <p *ngIf="message" class="mb-5 text-sm text-gray-500 dark:text-gray-400">
          {{ message }}
        </p>
        <button
          type="button"
          (click)="onConfirm()"
          [disabled]="loading"
          class="text-white bg-brand-green-600 hover:bg-brand-green-800 focus:ring-4 focus:outline-none font-medium rounded-lg text-sm inline-flex items-center px-5 py-2.5 text-center disabled:opacity-60"
        >
          {{ confirmText }}
        </button>
        <button
          type="button"
          (click)="onCancel()"
          [disabled]="loading"
          class="py-2.5 px-5 ms-3 text-sm font-medium text-gray-900 focus:outline-none bg-white rounded-lg border border-gray-200 hover:bg-gray-100 hover:text-red-700 focus:z-10 focus:ring-gray-100 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700 disabled:opacity-60"
        >
          {{ cancelText }}
        </button>
      </div>
    </div>
  </div>
</div>
